import { store } from '../../store'

export const deleteUser = async ( id: number ): Promise<boolean> => {

    let response: Response
    const token = store.getState().session.token

    try {

        response = await fetch( `${ process.env.REACT_APP_API_ORIGIN }/1.0.0/cms/users/${ id }`, {
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            },
            method: 'delete'
        } )

    } catch ( exception ) {

        store.dispatch( { type: 'DELETE_USER_TIMEOUT' } )
        return false

    }

    if ( response.status === 401 ) {

        store.dispatch( { type: 'DELETE_USER_UNAUTHORIZED' } )
        return false

    }

    if ( response.status !== 200 ) {

        store.dispatch( { type: 'DELETE_USER_UNEXPECTEDRESPONSE' } )
        return false

    }

    store.dispatch( { type: 'DELETE_USER_OK' } )
    return true

}
